import Handsontable from 'handsontable';
import { CellValue } from 'handsontable/common';
import { CellProperties } from 'handsontable/settings';

/**
 * Валидатор-костыль, необходим исключительно для таблиц где одна из колонок выбор из каталога,
 * а еще одно это количество.
 *
 * Основная задача — исключить выбор чего-либо из каталогов вне положенного диапазона.
 *
 * Для этого необходимо:
 * 1. настроить служебно наименование столбца,который будет являться источником (то что выбирают из каталога)
 * 2. у записей в параметрах `params` должны присутствовать ключи `min`, `max`.
 *
 * При неудачной валидации в свойствах ячейки будет установлен параметр `invalidTooltipText`.
 * @param value
 * @param callback
 * @constructor
 */
export default function CatalogRecordAmountValidator(
  this: CellProperties,
  value: CellValue,
  callback: (valid: boolean) => void
): void {
  let invalidTooltipText;
  const nativeNumericValidationResult = Handsontable.helper.isNumeric(value);
  if (!nativeNumericValidationResult) {
    callback(false);
    return;
  }

  const { columns: columnsFactory = [] } = this.instance.getSettings();

  const columns = typeof columnsFactory === 'function' ? columnsFactory(this.row) : columnsFactory;
  /**
   * catalogColumnSlug - служебное наименование столбца с типом значения из каталога
   */
  const { catalogColumnSlug } = this;
  if (!catalogColumnSlug) {
    callback(true);
    return;
  }
  const catalogColumnIndex = columns.findIndex((c) => c.data === catalogColumnSlug);
  if (catalogColumnIndex === -1) {
    callback(true);
    return;
  }

  /**
   * Добываем значения из каталога столбца "Выбор из каталога"
   */
  const { selectOptions: selectOptionsFactory = [] } = columns[catalogColumnIndex] || {};
  const selectOptions =
    typeof selectOptionsFactory === 'function'
      ? selectOptionsFactory(this.row, catalogColumnIndex)
      : selectOptionsFactory;

  /**
   * Ищем значение каталога, который выбран в соответсвующем столбце (catalogColumnSlug),
   * и пытаемся получить ограничение min, max/
   */
  const dataAtRow: CellValue[] = this.instance.getDataAtRow(this.row);
  const { params: { min, max } = { min: undefined, max: undefined } } =
    selectOptions.find(({ id }) => id === dataAtRow[catalogColumnIndex]) || {};

  let failedMaxValidation = false;
  let failedMinValidation = false;

  if (typeof min !== 'undefined') {
    failedMinValidation = value < min;
    if (failedMinValidation) {
      invalidTooltipText =
        `Значение ячейки должно быть больше либо равно ${min}.` +
        'Для выхода из режима редактирования нажмите Esc.';
    }
  }

  if (typeof max !== 'undefined') {
    failedMaxValidation = value > max;
    if (failedMaxValidation) {
      invalidTooltipText =
        `Значение ячейки должно быть меньше либо равно ${max}.` +
        'Для выхода из режима редактирования нажмите Esc.';
    }
  }
  const validationResult = !failedMinValidation && !failedMaxValidation;
  if (validationResult) {
    delete this.invalidTooltipText;
  } else {
    this.invalidTooltipText = invalidTooltipText;
  }
  callback(validationResult);
}
